/* eslint import/imports-first: 0 */
import React, { Component, PropTypes } from 'react';

class Pagination extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onPrevious = this.onPrevious.bind(this);
    }

    onChange(e) {
        this.props.onChange(parseInt(e.target.innerText, 10));
        return false;
    }

    onNext() {
        this.props.onChange(this.props.currentPage + 1);
        return false;
    }

    onPrevious() {
        this.props.onChange(this.props.currentPage - 1);
        return false;
    }

    render() {
        const {
            totalElements,
            currentPage,
            pageSize,
            showPrevNext,
            textPrev,
            textNext,
            showTotal,
            textOf,
            textResults
        } = this.props;
        const totalPages = Math.ceil(totalElements / pageSize);
        const previousIsDisabled = currentPage === 1 ? { disabled: 'disabled' } : null;
        const nextIsDisabled = currentPage === totalPages ? { disabled: 'disabled' } : null;
        const currentElms = currentPage * pageSize;
        const elmFrom = currentElms - pageSize + 1;
        const showElmTo = currentElms > totalElements ? totalElements : currentElms;
        const showElmFrom = elmFrom > showElmTo ? showElmTo : elmFrom;

        const previous = showPrevNext ? (
            <a
                onClick={this.onPrevious}
                className="spark-pagination__arrow spark-pagination__arrow--previous"
                {...previousIsDisabled}
            >
                <span className="spark-pagination__arrow-text">{textPrev}</span>
            </a>
        ) : null;

        const next = showPrevNext ? (
            <a
                onClick={this.onNext}
                className="spark-pagination__arrow spark-pagination__arrow--next"
                {...nextIsDisabled}
            >
                <span className="spark-pagination__arrow-text">{textNext}</span>
            </a>
        ) : null;

        const total = showTotal ? (
            <div className="spark-pagination__results">
                {totalElements > 0 ? (
                    <div className="spark-pagination__summary">
                        {showElmFrom}-{showElmTo} {textOf} {totalElements} {textResults}
                    </div>
                ) : (
                    <div className="spark-pagination__summary">
                        {totalElements} {textResults}
                    </div>
                )}
            </div>
        ) : null;

        const pages =
            totalPages <= 10
                ? [...new Array(totalPages).keys()].map(i => {
                      const page = i + 1;
                      const className = ['spark-pagination__item'];
                      if (currentPage === page) {
                          className.push('spark-pagination__item--active');
                      }
                      return (
                          <a key={i} className={className.join(' ')} onClick={this.onChange}>
                              {page}
                          </a>
                      );
                  })
                : [...new Array(totalPages).keys()].map(i => {
                      const page = i + 1;
                      const className = ['spark-pagination__item'];
                      if (currentPage === page) {
                          className.push('spark-pagination__item--active');
                      }
                      if (
                          page === 1 ||
                          page === totalPages ||
                          page === currentPage ||
                          page === currentPage + 1 ||
                          page === currentPage - 1
                      ) {
                          return (
                              <a key={i} className={className.join(' ')} onClick={this.onChange}>
                                  {page}
                              </a>
                          );
                      }
                      //   else if(page === currentPage + 1 || page === currentPage - 1){
                      //       return (<span key={i} className="spark-pagination__ellipsis" >...</span>);
                      //   }
                      else if ((page === 2 || page === totalPages - 1) && currentPage !== page) {
                          return (
                              <span key={i} className="spark-pagination__ellipsis">
                                  ...
                              </span>
                          );
                      }
                  });

        return (
            <nav className="spark-pagination">
                {totalPages > 1 ? (
                    <div className="spark-pagination__pages">
                        {previous}
                        {pages}
                        {next}
                    </div>
                ) : null}
                {total}
            </nav>
        );
    }
}

Pagination.propTypes = {
    totalElements: PropTypes.number, // total elements
    onChange: PropTypes.func, // callback which is called on click on a page or prev/next
    currentPage: (props, propName, componentName) => {
        if (typeof props[propName] !== 'number') {
            return new Error(`${componentName}: prop ${propName} needs to be a number!`);
        }
        if (props[propName] <= 0) {
            return new Error(`${componentName}: prop ${propName} needs to greater than 0!`);
        }
        return null;
    },
    pageSize: PropTypes.number.isRequired, // how many elements per page
    showPrevNext: PropTypes.bool.isRequired,
    textPrev: PropTypes.string,
    textNext: PropTypes.string,
    showTotal: PropTypes.bool.isRequired,
    textOf: PropTypes.string,
    textResults: PropTypes.string
};

Pagination.defaultProps = {
    totalElements: 100,
    onChange: pageNumber => {},
    currentPage: 1,
    pageSize: 10,
    showPrevNext: true,
    textPrev: 'Previous',
    textNext: 'Next',
    showTotal: true,
    textOf: 'of',
    textResults: 'results'
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/helpers/Pagination.js